import {
    WHITEBOARD_FILTER_BY_WORKING_ORDER,
    WHITEBOARD_PRODUCT_IMAGE_CHANGE,
    WHITEBOARD_PRODUCTS_CART,
    WHITEBOARD_PRODUCTS_CLEAR,
    WHITEBOARD_PRODUCTS_FETCH,
    WHITEBOARD_PRODUCTS_ORDER_FLOW_UPDATE,
    WHITEBOARD_PRODUCTS_PANEL_CLEAR,
} from "constants/action-types";

export const fetch = (filters) => ({
    payload: { filters },
    type: WHITEBOARD_PRODUCTS_FETCH,
});

export const fetchNextPage = (resolve?) => ({
    payload: { nextPage: true, resolve },
    type: WHITEBOARD_PRODUCTS_FETCH,
});

export const fetchSearchResults = (search) => ({
    payload: { filters: search },
    type: WHITEBOARD_PRODUCTS_FETCH,
});

export const fetchNextSearchResult = (search, resolve?) => ({
    payload: { filters: search, nextPage: true, resolve },
    type: WHITEBOARD_PRODUCTS_FETCH,
});

export const fetchProductsByIds = (ids) => ({
    payload: { filters: { _id: ids } },
    type: WHITEBOARD_PRODUCTS_FETCH,
});

export const addPageProductsToCart = (ids) => ({
    payload: { query: { _id: ids }, type: "items" },
    type: WHITEBOARD_PRODUCTS_CART,
});

export const changeProductImage = ({ url, position, component, whiteboard }) => ({
    payload: {
        component,
        position,
        url,
        whiteboard,
    },
    type: WHITEBOARD_PRODUCT_IMAGE_CHANGE,
});

export const clearProducts = () => ({ type: WHITEBOARD_PRODUCTS_CLEAR });

export const clearPanelProducts = () => ({ type: WHITEBOARD_PRODUCTS_PANEL_CLEAR });

export const filterByWorkingOrder = (isFilteringByWorkingOrder) => ({
    payload: isFilteringByWorkingOrder,
    type: WHITEBOARD_FILTER_BY_WORKING_ORDER,
});

export const updateOrderFlowType = (mode, adds) => ({
    payload: { mode, adds },
    type: WHITEBOARD_PRODUCTS_ORDER_FLOW_UPDATE,
});
